/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1LocationCountriesIdMutationRequest,
  PutApiV1LocationCountriesIdMutationResponse,
  PutApiV1LocationCountriesIdPathParams,
  PutApiV1LocationCountriesId400,
  PutApiV1LocationCountriesId401,
  PutApiV1LocationCountriesId404,
  PutApiV1LocationCountriesId409,
  PutApiV1LocationCountriesId500,
} from "../../types/locationCountryController/PutApiV1LocationCountriesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1LocationCountriesId } from "../../clients/locationCountryController/putApiV1LocationCountriesId.ts";

export const putApiV1LocationCountriesIdMutationKey = () =>
  [{ url: "/api/v1/location/countries/:id" }] as const;

export type PutApiV1LocationCountriesIdMutationKey = ReturnType<
  typeof putApiV1LocationCountriesIdMutationKey
>;

export function putApiV1LocationCountriesIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1LocationCountriesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1LocationCountriesIdMutationKey();
  return mutationOptions<
    PutApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesId400
      | PutApiV1LocationCountriesId401
      | PutApiV1LocationCountriesId404
      | PutApiV1LocationCountriesId409
      | PutApiV1LocationCountriesId500
    >,
    {
      id: PutApiV1LocationCountriesIdPathParams["id"];
      data?: PutApiV1LocationCountriesIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1LocationCountriesId(id, data, config);
    },
  });
}

/**
 * @description Atualiza a sigla, o nome e o status de um país, além da tradução no idioma corrente. A sigla e o nome devem permanecer únicos. **(Requer Authorization para autenticação)**
 * @summary Atualizar país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:id}
 */
export function usePutApiV1LocationCountriesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1LocationCountriesIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1LocationCountriesId400
        | PutApiV1LocationCountriesId401
        | PutApiV1LocationCountriesId404
        | PutApiV1LocationCountriesId409
        | PutApiV1LocationCountriesId500
      >,
      {
        id: PutApiV1LocationCountriesIdPathParams["id"];
        data?: PutApiV1LocationCountriesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1LocationCountriesIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1LocationCountriesIdMutationKey();

  const baseOptions = putApiV1LocationCountriesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesId400
      | PutApiV1LocationCountriesId401
      | PutApiV1LocationCountriesId404
      | PutApiV1LocationCountriesId409
      | PutApiV1LocationCountriesId500
    >,
    {
      id: PutApiV1LocationCountriesIdPathParams["id"];
      data?: PutApiV1LocationCountriesIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesId400
      | PutApiV1LocationCountriesId401
      | PutApiV1LocationCountriesId404
      | PutApiV1LocationCountriesId409
      | PutApiV1LocationCountriesId500
    >,
    {
      id: PutApiV1LocationCountriesIdPathParams["id"];
      data?: PutApiV1LocationCountriesIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesId400
      | PutApiV1LocationCountriesId401
      | PutApiV1LocationCountriesId404
      | PutApiV1LocationCountriesId409
      | PutApiV1LocationCountriesId500
    >,
    {
      id: PutApiV1LocationCountriesIdPathParams["id"];
      data?: PutApiV1LocationCountriesIdMutationRequest;
    },
    TContext
  >;
}
